// core version + navigation, pagination modules:
import Swiper, { Navigation, Autoplay } from 'swiper';

class FeedbackSlider {
    constructor() {
      if (document.querySelector(".ww-feedback__slider")) {
      // Actually init Swiper:
      var swiper = new Swiper('.ww-feedback__slider', {
        modules: [Navigation, Autoplay],
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        autoplay: {
            delay: 3000,
          },
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        breakpoints: {
            // when window width is >= 960px
            960: {
                slidesPerView: 3.5,
                spaceBetween: 20
            },
        },

        observer: true,  
        observeParents: true,

      });
    }
  }
}

export default FeedbackSlider